import { ReactElement, SyntheticEvent } from 'react';
import { EIconSize } from 'utils/constants/app/ui';
import { GlobalIcon } from 'components/GlobalIcon';
import './index.less';

type Props = {
  onClick: (e: SyntheticEvent) => void;
};

export const BackButton = (props: Props): ReactElement => {
  return (
    <GlobalIcon
      lib="generic"
      name="arrowLeft"
      theme="default"
      size={EIconSize._12}
      className="backButton backButton__btn"
      onClick={props.onClick}
    />
  );
};
